/**
 * 観測所検索
 */
import Repository from "./Repository";

const resource = "";
export default {
  /**
   * 観測所検索結果一覧取得
   * @param keyword キーワード
   * @param target 検索対象
   * @param obsType 観測種別
   */
  getRsltObsList(keyword, targets, obsType) {
    /** URLエンコーディング*/
    const key = encodeURIComponent(keyword);
    return Repository.get(
      `${resource}/search/list` + `/` + key + `/` + targets + `/` + obsType
    );
  },
};
